
























import { Component, Prop, Vue } from 'vue-property-decorator'; 
import { Action } from 'vuex-class' 
import {mapState} from 'vuex'
import ProdutoI from "@/Interfaces/Produto"

@Component({ 
   computed: mapState([ 
    'carrinho',
  ]),
}) 
export default class Item extends Vue { 
    @Prop() item!: ProdutoI  
    @Action('REMOVER_ITEM')
    REMOVER_ITEM!: (REMOVER_ITEM: void) => void 
    @Action('ATUALIZAR_QUANTIDADE')
    ATUALIZAR_QUANTIDADE!: (ATUALIZAR_QUANTIDADE) => void 

    get total(){
        return this.item.priceMember * this.item.quantity
    }

    removerItem(item){ 
        this.REMOVER_ITEM(item)
    }

    atualizarQuantidade(payload){
        this.ATUALIZAR_QUANTIDADE(payload)
    }

}
